import { DEFAULT_FUNNELS_FILTERS } from '../constants/funnels';
import {find} from 'lodash';

const initialState = {
  searchFunnelsParams: {
    searchText: '',
    ...DEFAULT_FUNNELS_FILTERS
  },
  onlyFunnelSteps: [],
  exported_funnels: [],
  totalPages: 0,
  loadingExportedFunnels: false,
  funnelFilter: '',
  funnels: [],
  selectedFunnel: {},
  dataVersion: 0,
  loadingFunnels: false,
  loading: false,
  error: null,
  dataVersion: 0
};

const funnelsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_FUNNEL_FILTERS': {
      return {
        ...state,
        funnelFilter: action.funnelFilter
      };
    }
    case 'INCREMENT_DATA_VERSION': {
      return {
        ...state,
        dataVersion: state.dataVersion + 1
      };
    }
    case 'SET_FUNNEL_SEARCH_PARAMS': {
      return {
        ...state,
        searchFunnelsParams: {
          ...state.searchFunnelsParams,
          searchText: action.params.searchText
        }
      };
    }
    case 'SET_FUNNEL_SEARCH_FILTER': {
      return {
        ...state,
        searchFunnelsParams: {
          ...state.searchFunnelsParams,
          amount: action.filters.amount,
          amount_condition: action.filters.amount_condition,
          agents: action.filters.agents,
          lead_status: action.filters.lead_status,
          excluded_tags: action.filters.excluded_tags,
          included_tags: action.filters.included_tags,
          start_created_at: action.filters?.start_created_at || '',
          end_created_at: action.filters?.end_created_at || '',
          start_expected_close_date: action.filters?.start_expected_close_date || '',
          end_expected_close_date: action.filters?.end_expected_close_date || ''
        },
        filtersApplied: state.filtersApplied || 1
      };
    }
    case 'CLEAR_FUNNEL_SEARCH_FILTER': {
      return {
        ...state,
        searchFunnelsParams: {
          ...state.searchFunnelsParams,
          ...DEFAULT_FUNNELS_FILTERS
        },
        filtersApplied: state.filtersApplied || 1
      };
    }
    case 'GET_ONLY_FUNNELS_STEPS': {
      return {
        ...state,
        onlyFunnelSteps: action.data.funnelSteps
      };
    }
    case 'GET_FUNNELS_START':
      return {
        ...state,
        loadingFunnels: true,
        error: null
      };
    case 'GET_FUNNELS_END':
      return {
        ...state,
        loadingFunnels: false
      };
    case 'GET_FUNNELS_ERROR':
      return {
        ...state,
        loadingFunnels: false,
        error: action.error
      };
    case 'FUNNELS_ALREADY_LOADED':
      return {
        ...state,
        loadingFunnels: false,
        error: null
      };
    case 'GET_EXPORTED_FUNNELS_START':
      return {
        ...state,
        loadingExportedFunnels: true
      };
    case 'GET_EXPORTED_FUNNELS':
      return {
        ...state,
        exported_funnels: action.data.funnel_exports,
        totalPages: action.data.total_pages
      };
    case 'GET_EXPORTED_FUNNELS_END':
      return {
        ...state,
        loadingExportedFunnels: false
      };
    case 'SET_FUNNELS':
      return {
        ...state,
        funnels: action.data?.funnels ?? [],
        loadingFunnels: false,
        error: null
      };
    case 'ADD_FUNNELS':
      return {
        ...state,
        funnels: state.funnels.map((item) => {
          if (item.web_id === action.funnelId) {
            return {
              ...item,
              funnel_steps: [...item.funnel_steps, action.data]
            };
          }
          return item;
        })
      };
    case 'UPDATE_FUNNELS':
      return {
        ...state,
        funnels: state.funnels.map((item) => {
          if (item.web_id === action.funnelId) {
            return {
              ...item,
              funnel_steps: item.funnel_steps.map((step) => {
                if (step.web_id === action.data.web_id) {
                  return action.data;
                }
                return step;
              })
            };
          }
          return item;
        })
      };
    case 'SET_SELECTED_FUNNEL':
      return {
        ...state,
        selectedFunnel: action.data
      };
    case 'FETCH_FUNNELS_REQUEST':
      return {
        ...state,
        loading: true,
        error: null
      };
    case 'FETCH_FUNNELS_SUCCESS':
      return {
        ...state,
        loading: false,
        funnels: action.payload
      };
    case 'FETCH_FUNNELS_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default funnelsReducer;
